import 'whatwg-fetch';
import Modal from '../modal';
import Pager from '../paging';

export default class Filtering {
    constructor (component) {
        if ('URLSearchParams' in window) {
            this.component = component;
            this.apiUrl = this.component.getAttribute('data-filtering-url');
            this.container = this.component.querySelector('[data-filtering-results]');
            this.queryParams = new URLSearchParams(window.location.search);
            this.tags = this.component.querySelectorAll('[data-filtering-tag]');

            this.isDownloadBlockFiltering = this.component.hasAttribute('data-filtering-download') ? true : false;

            this.pager = null;

            if (!this.apiUrl || !this.container) return;

            this.init();
            this.bindHandlers();
        }
    }
    
    updateQueryUrl() {
        window.history.replaceState({}, '', `${window.location.pathname}?${this.queryParams}`);
    }

    bindHandlers() {
        const modals = this.component.querySelectorAll('[data-filter-modal]');
        modals.forEach(modal => {
            new Modal(modal)
        })

        const pager = new Pager(this.component.querySelector('[data-filter-paging]'));
        if (pager.el) {
            pager.el.addEventListener('onPage', (e) => {
                this.page = e.detail.page;
                this.updateItems();
            });
        }
    }

    updateItems() {
        if (!this.isDownloadBlockFiltering) {
            fetch(this.apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    PageId: this.component.getAttribute('data-filtering-pageid'),
                    Tags: this.queryParams.get('tags'),
                    Q: this.queryParams.get('q')
                })
            })
                .then(response => response.text())
                .then(results => {
                    this.container.innerHTML = results;
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        } else {
            fetch(this.apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    BlockId: this.component.getAttribute('data-filtering-blockid'),
                    Tags: this.queryParams.get('tags'),
                    // Q: this.queryParams.get('q')
                })
            })
                .then(response => response.text())
                .then(results => {
                    this.container.innerHTML = results;
                    this.container.style = '';

                    setTimeout(() => this.bindHandlers(), 150);
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    }
    
    tagEventHandler(root, tag) {
        const tagValue = tag.getAttribute('data-filtering-tag');
        const currentValue = root.queryParams.get('tags');
        let newValue = [];
        
        if (currentValue) {
            newValue = currentValue.split(',');
        }
        
        if (newValue.includes(tagValue)) {
            tag.classList.remove('is-active');
            newValue.splice(newValue.indexOf(tagValue), 1);
        } else {
            tag.classList.add('is-active');
            newValue.push(tagValue);
        }
        
        root.queryParams.set('tags', newValue.toString());
        root.updateQueryUrl();

        // We're saving some styles here so it'll make for a smoother transition
        root.container.style.height = root.container.offsetHeight + 'px';
        root.container.style.transition = '0.2s';
        root.container.style.opacity = 0;

        setTimeout(() => {
            root.updateItems();
        }, 300);
        
        setTimeout(() => {
            root.container.style.height = 'auto';
            root.container.style.opacity = 1;
        }, 700);
    }
    
    init() {
        const root = this;
        
        this.tags.forEach(tag => {
            tag.addEventListener('click', event => {
                event.preventDefault();
                root.tagEventHandler(root, tag);
            });
        });
    }
}